import { useState, useEffect } from 'react';
const useStandalone = () => {
    const [isStandalone, setIsStandalone] = useState(false);

    useEffect(() => {
        setIsStandalone(window.matchMedia("(display-mode: standalone)").matches);
    }, []);

    return { isStandalone };
};

export default useStandalone;